<template>
  <div class="product__infoImg" v-if="isProductBrandLogo(productBrandLogo)">
    <div class="imgWrap">
      <nuxt-link v-if="productBrandLogo.url_key" :to="productBrandLogo.url_key">
        <SfImage :src="productBrandLogo.logo" alt="icon" :width="115" :height="40" v-if="productBrandLogo.logo" />
        <span v-else>{{ productBrandLogo.title }}</span>
      </nuxt-link>
      <template v-else>
        <SfImage v-if="productBrandLogo.logo" :src="productBrandLogo.logo" alt="icon" :width="115" :height="40" />
        <span v-else>{{ productBrandLogo.title }}</span>
      </template>
    </div>
  </div>
</template>
<script>
import { SfImage } from '@storefront-ui/vue';

import { useApi } from '~/composables';
import getProductBrandLogoGql from '~/customQueries/getProductBrandLogo.gql';
import { ref, defineComponent, onMounted } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'ProductBrandLogo',
  components: {
    SfImage,
  },
  props: {
    sku: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    const { query } = useApi();
    const productBrandLogo = ref(null);

    const fetchBrandLogoData = async () => {
      try {
        if (!props.sku) return;

        const { data } = await query(getProductBrandLogoGql, { sku: props.sku });

        if (data) {
          // @ts-ignore
          productBrandLogo.value = data.brand_logo || null;
        }
      } catch (e) {
        console.log('fetchBrandLogoData Error: ', e);
      }
    };

    const isProductBrandLogo = (productBrandLogo) => {
      if (productBrandLogo?.title || productBrandLogo?.logo) {
        return true;
      } else {
        return false;
      }
    };

    onMounted(async () => {
      await fetchBrandLogoData();
    });

    return {
      productBrandLogo,
      isProductBrandLogo,
    };
  },
});
</script>
<style lang="scss" scoped></style>
